/*
<summary>
   This functional common component provides us custom label tag that show the field is required or not.
   Developer:Aashish Singh, Created Date:08-Mar-2023
</summary>
<returns>Returns JSX</returns>
*/
import React, { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { NavLink, useHistory } from 'react-router-dom';
import { getUserType } from '../../helpers/localstorage-helper';
import { formatMessage } from '../../translations/format-message';
import RoutesConstants from '../routes/routes-constants';

interface IProps {
  label: string;
  className?: string;
  bomState?: string;
}

const Header: React.FC<IProps> = (props) => {
  const history = useHistory();
  const isBomBack =
    props.label === 'parts_search' || props.label === 'material_tag_assign';
  const backRoute = isBomBack
    ? RoutesConstants.BomSearch
    : RoutesConstants.FactoryAccess;

  useEffect(() => {
    const handleBack = () => {
      if (!isBomBack) {
        localStorage.setItem('oms_access_tenant_id', '-1');
        history.replace(backRoute);
      } else {
        // localStorage.setItem('bom', '')
        history.replace({
          pathname: backRoute,
          state: {
            filters: props.bomState, // 👈 pass filters
            fromBack: true,
          },
        });
      }
      //  if (!isBomBack) {
      //   localStorage.setItem('oms_access_tenant_id', '-1');
      // }
      history.replace(backRoute);
    };

    window.addEventListener('popstate', handleBack);

    // Push a dummy state so popstate always fires
    window.history.pushState(null, '', window.location.pathname);

    return () => {
      window.removeEventListener('popstate', handleBack);
    };
  }, [backRoute, history, isBomBack]);

  return (
    // <div className="icon-nav navbar-fixed-top device-nav-bar userTopNav">
    //   <div className="row align-items-center">
    <div className={`${props.className}`}>
      <div className="page_title_wrap">
        <ul className="add-list operator-back">
          <li className="process-chart">
            {(isBomBack || getUserType() === 'SuperAdministrator' ||
              getUserType() === 'DIDManager') && (
              <NavLink
                title={formatMessage(props.label)}
                // to={backRoute}
                to={
                  isBomBack
                    ? {
                        pathname: backRoute,
                        state: {
                          filters: props.bomState,
                          fromBack: true,
                        },
                      }
                    : backRoute
                }
                className="btn btn-secondary"
                onClick={() => {
                  if (!isBomBack) {
                    localStorage.setItem('oms_access_tenant_id', '-1');
                  }
                  // else {
                  //   localStorage.setItem('bom', '');
                  // }
                }}
              >
                <FormattedMessage id="back" />
              </NavLink>
            )}
          </li>
          <li>
            {' '}
            <h1 className="page_title">
              <FormattedMessage id={props.label} />
            </h1>
          </li>
        </ul>
      </div>
    </div>
    //   </div>
    // </div>
  );
};
export default Header;
